/* MURO — comportements du thème Shopify : visuels, panier (API AJAX Shopify), filtres, quiz, fiche produit. */

const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const SHOP = window.MURO_SHOP || { root: '/', products: {} };
const shopUrl = path => (SHOP.root.endsWith('/') ? SHOP.root : SHOP.root + '/') + path;
const money = cents => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: SHOP.currency || 'EUR' }).replace(/[,.]00(?=\s|$)/, '');
const shopInfo = p => (p && SHOP.products[p.handle]) || null;
const priceOf = p => (shopInfo(p) ? money(shopInfo(p).price) : euro(p.price));
const urlOf = p => (shopInfo(p) ? shopInfo(p).url : shopUrl(`products/${p.handle}`));
// Précommande : libellé des boutons + mention ajoutée à chaque ligne (visible au panier, au paiement et dans l'email de commande)
const PREORDER = SHOP.preorder ? { 'Précommande': `expédition estimée ${SHOP.preorderShip}` } : null;
const ADD_LABEL = SHOP.preorder ? 'Précommander' : 'Ajouter';

/* ---------- Visuels et cartes ---------- */

// Les grilles suivent l'ordre du catalogue (Monceau → Marais → Bastille → Étoile → accessoires)
const catalogRank = handle => { const i = ALL_PRODUCTS.findIndex(p => p.handle === handle); return i < 0 ? 99 : i; };
function orderGrids(root = document) {
  $$('.grid-products', root).forEach(grid => {
    const cards = $$(':scope > [data-card]', grid);
    if (cards.length < 2) return;
    cards.sort((a, b) => catalogRank(a.dataset.handle) - catalogRank(b.dataset.handle)).forEach(c => grid.appendChild(c));
  });
}

function hydrate(root = document) {
  orderGrids(root);
  $$('[data-visual]', root).forEach(el => {
    const p = findByHandle(el.dataset.visual);
    if (!p) return;
    el.innerHTML = productVisual(p, { view: el.dataset.view || 'front' });
    const host = el.closest('[data-bg]');
    if (host) {
      host.style.setProperty('--bg', p.bg);
      host.style.color = p.dark ? '#F6F1E7' : '#111111';
    }
  });
  $$('[data-card]', root).forEach(card => {
    const p = findByHandle(card.dataset.handle);
    if (!p) return;
    const badge = $('[data-badge]', card);
    if (badge && p.badge) { badge.textContent = p.badge; badge.hidden = false; }
    const spec = $('[data-spec]', card);
    if (spec) spec.textContent = p.type === 'racket' ? p.motif : p.desc;
    const tags = $('[data-tags]', card);
    if (tags && p.type === 'racket') tags.innerHTML = `<span class="tag">${p.place} · ${p.num}</span><span class="tag">Carbone 12K</span>`;
  });
}

/* ---------- Toast ---------- */

let toastTimer;
function toast(msg) {
  const t = $('#toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('is-on');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('is-on'), 2800);
}

/* ---------- Panier (API AJAX Shopify) ---------- */

const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const cartApi = {
  async get() {
    const r = await fetch(shopUrl('cart.js'), { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('Le panier est indisponible. Réessaie dans un instant.');
    return r.json();
  },
  async post(path, body) {
    const r = await fetch(shopUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'Impossible de modifier le panier.');
    return data;
  },
  add(items) { return this.post('cart/add.js', { items: PREORDER ? items.map(i => ({ ...i, properties: { ...PREORDER, ...(i.properties || {}) } })) : items }); },
  change(key, quantity) { return this.post('cart/change.js', { id: key, quantity }); }
};

function renderCart(cart) {
  $$('.cart-count').forEach(el => { el.textContent = cart.item_count; el.dataset.n = cart.item_count; });
  const drawer = $('.drawer');
  if (!drawer) return;
  $('[data-drawer-count]').textContent = ` (${cart.item_count})`;
  const shipping = $('#ship-msg');
  const threshold = Number(SHOP.freeShipping);
  shipping.hidden = !cart.item_count || SHOP.showShippingProgress === false || SHOP.currency !== 'EUR' || !(threshold > 0);
  if (!shipping.hidden) {
    const left = Math.max(0, threshold - cart.total_price);
    const pct = Math.min(100, cart.total_price / threshold * 100);
    shipping.innerHTML = `${left > 0 ? `Encore <b>${money(left)}</b> avant le seuil de livraison offerte.` : '<b>Seuil de livraison offerte atteint !</b>'}
      <div class="bar__track" aria-hidden="true"><div style="width:${pct}%"></div></div>
      <small>Selon destination · tarif confirmé au paiement.</small>`;
  }
  if (!cart.item_count) {
    $('#cart-items').innerHTML = `<div class="drawer__empty"><img src="${SHOP.assets}marcel.svg" alt="" width="110" height="115"><p>Marcel trouve ton panier bien vide.</p><a class="btn btn--sm" href="${shopUrl('collections/all')}">Trouver ma raquette</a></div>`;
    $('#cart-foot').innerHTML = '';
    return;
  }
  $('#cart-items').innerHTML = cart.items.map(l => {
    const p = findByHandle(l.handle);
    const visual = p ? productVisual(p) : (l.image ? `<img src="${escapeHTML(l.image)}" alt="" loading="lazy">` : '');
    const variant = l.variant_title && l.variant_title !== 'Default Title' ? escapeHTML(l.variant_title) : '';
    const sub = variant || (p && p.type === 'racket' ? escapeHTML(`${p.shape} · ${p.face}`) : '');
    const name = escapeHTML(l.product_title.split(' — ')[0]);
    const key = escapeHTML(l.key);
    const properties = Object.entries(l.properties || {}).filter(([k, v]) => !k.startsWith('_') && v).map(([k, v]) => `<div class="line__sub">${escapeHTML(k)} : ${escapeHTML(v)}</div>`).join('');
    const discounts = (l.line_level_discount_allocations || []).map(d => `<span class="cart-discount">${escapeHTML(d.discount_application.title)} · − ${money(d.amount)}</span>`).join('');
    return `<div class="line">
      <a class="line__img" href="${escapeHTML(l.url)}" aria-label="${name}" style="--bg:${p ? p.bg : '#ECE6DA'}">${visual}</a>
      <div>
        <a class="line__name" href="${escapeHTML(l.url)}">${name}</a>
        <div class="line__sub">${sub}</div>${properties}${discounts}
        <div class="qty" role="group" aria-label="Quantité de ${name}">
          <button type="button" data-line="${key}" data-q="${l.quantity - 1}" aria-label="Retirer un ${name}">−</button>
          <output aria-label="Quantité">${l.quantity}</output>
          <button type="button" data-line="${key}" data-q="${l.quantity + 1}" aria-label="Ajouter un ${name}">+</button>
        </div>
      </div>
      <div class="line__right">${l.original_line_price > l.final_line_price ? `<s class="line__old-price">${money(l.original_line_price)}</s>` : ''}<span class="price">${money(l.final_line_price)}</span><button class="link-btn" type="button" data-line="${key}" data-q="0" aria-label="Retirer ${name} du panier">Retirer</button></div>
    </div>`;
  }).join('');
  const discounts = (cart.cart_level_discount_applications || []).map(d => `<div class="cart-discount"><span>${escapeHTML(d.title)}</span><span>− ${money(d.total_allocated_amount)}</span></div>`).join('');
  $('#cart-foot').innerHTML = `
    ${SHOP.preorder ? `<p class="cart-preorder"><b>Précommande</b> · expédition estimée ${escapeHTML(SHOP.preorderShip)}. Tu es débité à la commande et prévenu par email dès l’envoi.</p>` : ''}
    ${discounts}<div class="drawer__total"><span>Sous-total</span><span class="price">${money(cart.total_price)}</span></div>
    <p class="cart-summary-note">${cart.taxes_included ? 'Taxes incluses. ' : ''}Livraison et éventuelles taxes calculées au paiement.</p>
    <form action="${SHOP.cartUrl || shopUrl('cart')}" method="post"><button class="btn btn--rouge btn--block" type="submit" name="checkout">Passer au paiement <span class="arrow" aria-hidden="true">→</span></button></form>
    ${$('#cart-reassurance-template')?.innerHTML || ''}
    <button type="button" class="cart-continue" data-close-cart>Continuer mes achats</button>`;
}

const refreshCart = async () => renderCart(await cartApi.get());
let cartReturnFocus;
let cartBusy = false;
function openCart() {
  const drawer = $('.drawer');
  if (!drawer) return;
  if (!document.documentElement.classList.contains('is-cart-open')) cartReturnFocus = document.activeElement;
  document.documentElement.classList.add('is-cart-open');
  drawer.inert = false;
  drawer.setAttribute('aria-hidden', 'false');
  $$('[data-open-cart]').forEach(el => el.setAttribute('aria-expanded', 'true'));
  [...document.body.children].filter(el => !el.contains(drawer) && !el.matches('.drawer-scrim, #toast, script, template')).forEach(el => {
    if (!el.inert) { el.inert = true; el.dataset.cartInert = 'true'; }
  });
  $('[data-close-cart]', drawer)?.focus();
}
function closeCart() {
  const drawer = $('.drawer');
  if (!drawer) return;
  document.documentElement.classList.remove('is-cart-open');
  $$('[data-cart-inert]').forEach(el => { el.inert = false; delete el.dataset.cartInert; });
  drawer.inert = true;
  drawer.setAttribute('aria-hidden', 'true');
  $$('[data-open-cart]').forEach(el => el.setAttribute('aria-expanded', 'false'));
  if (cartReturnFocus?.isConnected) cartReturnFocus.focus();
}
function cartError(err) {
  const message = err.message || 'Connexion interrompue. Réessaie dans un instant.';
  const feedback = $('#cart-feedback');
  if (feedback) feedback.textContent = message;
  toast(message);
}
async function addItems(items, btn) {
  if (cartBusy) return;
  cartBusy = true;
  if (btn) btn.disabled = true;
  try {
    await cartApi.add(items);
    await refreshCart();
    $('#cart-feedback').textContent = 'Ajouté au panier.';
    openCart();
  } catch (err) { cartError(err); }
  finally { cartBusy = false; if (btn) btn.disabled = false; }
}

document.addEventListener('click', async e => {
  const t = e.target.closest('[data-open-cart],[data-close-cart],[data-line],[data-add-variant]');
  if (!t) return;
  if (t.matches('[data-close-cart]')) { closeCart(); return; }
  e.preventDefault();
  if (cartBusy) return;
  if (t.matches('[data-add-variant]')) { await addItems([{ id: Number(t.dataset.addVariant), quantity: 1 }], t); return; }
  cartBusy = true;
  const drawer = $('.drawer');
  drawer?.setAttribute('aria-busy', 'true');
  try {
    if (t.matches('[data-open-cart]')) { await refreshCart(); $('#cart-feedback').textContent = ''; openCart(); }
    else if (t.matches('[data-line]')) {
      const key = t.dataset.line;
      const direction = t.textContent.trim();
      renderCart(await cartApi.change(key, Number(t.dataset.q)));
      $('#cart-feedback').textContent = 'Panier mis à jour.';
      const candidates = $$('[data-line]').filter(el => el.dataset.line === key);
      (candidates.find(el => el.textContent.trim() === direction) || $('[data-close-cart]', drawer))?.focus();
    }
  } catch (err) {
    cartError(err);
    if (t.matches('[data-open-cart]')) window.location.assign(SHOP.cartUrl || shopUrl('cart'));
  } finally { cartBusy = false; drawer?.removeAttribute('aria-busy'); }
});
document.addEventListener('submit', e => {
  if (cartBusy && e.target.closest('.drawer')) e.preventDefault();
});
document.addEventListener('keydown', e => {
  if (!document.documentElement.classList.contains('is-cart-open')) return;
  if (e.key === 'Escape') { closeCart(); return; }
  if (e.key === 'Tab') {
    const focusable = $$('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]', $('.drawer'));
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === $('.drawer'))) { e.preventDefault(); last?.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
  }
});

/* ---------- Menu mobile ---------- */

function initMenu() {
  const burger = $('.burger');
  burger?.addEventListener('click', () => {
    const open = $('#nav').classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open);
  });
}

/* ---------- Collection : filtres et tri ---------- */

function initCollection() {
  const grid = $('[data-collection-grid]');
  if (!grid || !$('.chip[data-filter]')) return;
  const cards = $$('[data-card]', grid);
  const state = { play: null, level: null, shape: null, sort: 'reco' };
  const draw = () => {
    let shown = 0;
    cards.forEach(card => {
      const p = findByHandle(card.dataset.handle);
      const ok = !p || p.type !== 'racket' || (
        (!state.play || p.play.includes(state.play)) &&
        (!state.level || p.levels.includes(state.level)) &&
        (!state.shape || p.shapeKey === state.shape));
      card.hidden = !ok;
      if (ok) shown++;
    });
    const sorted = [...cards].sort((a, b) => state.sort === 'reco' ? catalogRank(a.dataset.handle) - catalogRank(b.dataset.handle)
      : (state.sort === 'asc' ? 1 : -1) * (Number(a.dataset.price) - Number(b.dataset.price)));
    sorted.forEach(c => grid.appendChild(c));
    $('#result-count').textContent = `${shown} raquette${shown > 1 ? 's' : ''}`;
    $('#collection-empty').hidden = shown > 0;
  };
  $$('.chip[data-filter]').forEach(chip => chip.addEventListener('click', () => {
    const { filter, value } = chip.dataset;
    state[filter] = state[filter] === value ? null : value;
    $$(`.chip[data-filter="${filter}"]`).forEach(c => c.setAttribute('aria-pressed', c.dataset.value === state[filter]));
    draw();
  }));
  $('#sort')?.addEventListener('change', e => { state.sort = e.target.value; draw(); });
  draw();
}

/* ---------- Fiche produit ---------- */

function initProduct() {
  const root = $('[data-product]');
  if (!root) return;
  const p = findByHandle(root.dataset.product);

  // vues face / détail / profil
  $$('[data-view-btn]', root).forEach(btn => btn.addEventListener('click', () => {
    $$('[data-view-btn]', root).forEach(b => b.setAttribute('aria-pressed', b === btn));
    const stage = $('[data-stage] [data-visual]', root);
    if (stage && p) { stage.dataset.view = btn.dataset.viewBtn; stage.innerHTML = productVisual(p, { view: btn.dataset.viewBtn }); }
  }));

  // compléments de fiche issus du catalogue
  const extras = $('[data-product-extras]', root);
  if (extras && p && p.type === 'racket') {
    $('[data-eyebrow]', root).textContent = `${p.badge} · ${p.place}, ${p.arr}ᵉ arr.`;
    extras.innerHTML = `
      <p class="pdp__tagline">${p.tagline}</p>
      <div class="marcel-says"><img src="${SHOP.assets}marcel.svg" alt=""><p><strong>L’avis de Marcel :</strong> ${p.vibe} C’est ton quartier.</p></div>`;
    $('[data-product-meta]', root).innerHTML = [p.shape, p.face, p.core, p.weight].map(t => `<span class="tag">${t}</span>`).join('');
    $('[data-product-stats]', root).innerHTML = Object.entries(p.stats).map(([k, v]) =>
      `<div class="stat"><span>${k}</span><div class="stat__track"><div class="stat__fill" data-w="${v}"></div></div><span class="stat__v">${v}</span></div>`).join('');
    requestAnimationFrame(() => $$('.stat__fill', root).forEach(el => { el.style.width = el.dataset.w + '%'; }));
    if (p.id === 'etoile') $('[data-stage]', root).insertAdjacentHTML('beforeend', '<div class="sticker"><span><b>300</b>ex. numérotés</span></div>');
  }

  // quantité + ajout (avec accessoires cochés)
  const form = $('form[data-product-form]', root);
  if (!form) return;
  const qtyInput = $('[name="quantity"]', form);
  const label = $('[data-add-label]', form);
  const unit = Number(form.dataset.price);
  const setQ = q => { qtyInput.value = Math.max(1, Math.min(9, q)); if (label) label.textContent = `${SHOP.preorder ? 'Précommander' : 'Ajouter au panier'} · ${money(unit * qtyInput.value)}`; };
  $('[data-q-minus]', form)?.addEventListener('click', () => setQ(Number(qtyInput.value) - 1));
  $('[data-q-plus]', form)?.addEventListener('click', () => setQ(Number(qtyInput.value) + 1));
  form.addEventListener('submit', e => {
    e.preventDefault();
    const items = [{ id: Number($('[name="id"]', form).value), quantity: Number(qtyInput.value) }];
    $$('.addons input:checked', form).forEach(i => items.push({ id: Number(i.value), quantity: 1 }));
    addItems(items, $('[type="submit"]', form));
  });
}

function cardHTML(r) {
  const info = shopInfo(r);
  return `<article class="card" data-card data-handle="${r.handle}">
    <a class="card__media" href="${urlOf(r)}" style="--bg:${r.bg}" aria-label="Voir la ${r.name}">${racketSVG(r.id)}<span class="card__badge">${r.badge}</span></a>
    <div class="card__body">
      <div class="card__top"><h3 class="card__name"><a href="${urlOf(r)}">${r.name}</a></h3><span class="price">${priceOf(r)}</span></div>
      <p class="mono card__spec">${r.motif}</p>
      <div class="tags"><span class="tag">${r.place} · ${r.num}</span></div>
      <div class="card__foot">
        <a class="btn btn--sm btn--creme" href="${urlOf(r)}">Détails</a>
        ${info && info.available ? `<button class="btn btn--sm" type="button" data-add-variant="${info.variant}">${ADD_LABEL}</button>` : ''}
      </div>
    </div>
  </article>`;
}

function initCompare() {
  const box = $('[data-compare]');
  if (!box) return;
  box.innerHTML = RACKETS.filter(r => r.handle !== box.dataset.compare).map(cardHTML).join('');
}

/* ---------- Quiz ---------- */

function initQuiz() {
  const box = $('#quiz');
  if (!box) return;
  const Q = [
    { k: 'after', t: 'Après le match, tu files…', o: [
      ['terrasse', 'En terrasse', 'Un verre au soleil, on refait le match.'],
      ['diner', 'Dîner chic', 'Nappe blanche et bon vin.'],
      ['nuit', 'Faire la fête', 'La soirée ne fait que commencer.']] },
    { k: 'jeu', t: 'Sur le terrain, tu es…', o: [
      ['stratege', 'Le stratège', 'Je place, je construis, je patiente.'],
      ['showman', 'Le showman', 'Je tente les coups impossibles.'],
      ['bulldozer', 'Le bulldozer', 'Je monte au filet et je smashe.']] },
    { k: 'style', t: 'Ta tenue de padel ?', o: [
      ['classique', 'Classique', 'Blanc, bleu marine, impeccable.'],
      ['couleur', 'Couleur', 'Plus c’est vif, mieux c’est.'],
      ['noir', 'Tout en noir', 'Sobre, efficace, mystérieux.']] },
    { k: 'envie', t: 'Ce qui compte le plus ?', o: [
      ['rare', 'Être le seul à l’avoir', 'Une série limitée, numérotée.'],
      ['style', 'Le style', 'Qu’on me remarque sur le terrain.'],
      ['plaisir', 'Le plaisir', 'Jouer, rire, recommencer.'],
      ['victoire', 'La victoire', 'Je joue pour gagner.']] }
  ];
  const W = {
    after: { terrasse: { marais: 3, 'saint-germain': 1 }, diner: { monceau: 3, opera: 1 }, nuit: { bastille: 2, etoile: 2 } },
    jeu: { stratege: { monceau: 2, 'saint-germain': 2 }, showman: { opera: 3, etoile: 1 }, bulldozer: { bastille: 3, marais: 1 } },
    style: { classique: { 'saint-germain': 3, monceau: 1 }, couleur: { marais: 2, opera: 2, bastille: 1 }, noir: { etoile: 3 } },
    envie: { rare: { etoile: 3 }, style: { 'saint-germain': 2, opera: 2 }, plaisir: { marais: 2, monceau: 1 }, victoire: { bastille: 3 } }
  };
  const answers = {};
  let step = 0;

  const show = () => {
    $('#quiz-bar').style.width = (step / Q.length) * 100 + '%';
    if (step >= Q.length) return result();
    const q = Q[step];
    box.innerHTML = `<div class="quiz__q">
      <span class="mono muted">Question ${step + 1} / ${Q.length}</span>
      <h2>${q.t}</h2>
      <div class="quiz__opts">${q.o.map(([v, t, s]) => `<button class="opt" type="button" data-v="${v}"><strong>${t}</strong><span>${s}</span></button>`).join('')}</div>
      ${step ? '<button class="quiz__back" type="button" id="back">← Question précédente</button>' : ''}
    </div>`;
    $$('.opt', box).forEach(b => b.addEventListener('click', () => { answers[q.k] = b.dataset.v; step++; show(); }));
    $('#back')?.addEventListener('click', () => { step--; show(); });
  };

  const result = () => {
    const score = { marais: 0.3, monceau: 0.25, bastille: 0.2, 'saint-germain': 0.15, opera: 0.1, etoile: 0 };
    Object.entries(answers).forEach(([k, v]) => Object.entries(W[k][v]).forEach(([m, pts]) => { score[m] += pts; }));
    const [first, second] = Object.entries(score).sort((a, b) => b[1] - a[1]).map(([m]) => findProduct(m));
    const info = shopInfo(first);
    box.innerHTML = `<div class="result">
      <div class="result__art" style="--bg:${first.bg}">${racketSVG(first.id)}</div>
      <div>
        <span class="eyebrow">Ton quartier · ${first.place}, ${first.arr}ᵉ</span>
        <h2>${first.name}</h2>
        <p class="pdp__tagline">${first.tagline}</p>
        <p>${first.vibe} ${first.desc[0]}</p>
        <ul>${first.forWho.map(f => `<li>${f}</li>`).join('')}</ul>
        <p class="muted">Même raquette pour tous : carbone 12K, EVA Medium, ${first.weight}.</p>
        <div class="hero__ctas">
          ${info && info.available ? `<button class="btn btn--rouge" type="button" data-add-variant="${info.variant}">${ADD_LABEL} · ${priceOf(first)}</button>` : ''}
          <a class="btn btn--creme" href="${urlOf(first)}">Voir la fiche</a>
        </div>
        <p class="muted" style="margin-top:22px">Deuxième choix : <a href="${urlOf(second)}" style="text-decoration:underline">${second.name}</a> (${priceOf(second)}). <button class="link-btn" type="button" id="restart">Refaire le test</button></p>
      </div>
    </div>`;
    $('#restart').addEventListener('click', () => { step = 0; show(); });
  };
  show();
}

/* ---------- Démarrage ---------- */

initMenu();
hydrate();
initCollection();
initProduct();
initCompare();
initQuiz();
refreshCart().catch(() => {});
